import { render, staticRenderFns } from "./Highscore.vue?vue&type=template&id=51502b63&scoped=true&"
import script from "./Highscore.vue?vue&type=script&lang=js&"
export * from "./Highscore.vue?vue&type=script&lang=js&"
import style0 from "./Highscore.vue?vue&type=style&index=0&id=51502b63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51502b63",
  null
  
)

export default component.exports